export const factoryTypes = {
  bySearch: 'bySearch',
  treeBySearch: 'treeBySearch',
  byParam: 'byParam',
  byParams: 'byParams',
};
